(function () {
    'use strict';

    angular
        .module(app.modules.common.name)
        .filter('fileextension', fileExtensionFactory);

    function fileExtensionFactory() {
        return function fileExtension(filename) {
            return filename && filename.substr(filename.lastIndexOf('.') + 1) || null;
        }
    };
})();